import { useQuery } from "@tanstack/react-query";
import { getDoctorSymptoms } from "../../../services/doctors";

import { useToast } from "../../../components/ui/use-toast";
import { useEffect } from "react";

export function useSymptoms({
  enabled = true,
  specialityIds,
}: {
  enabled: boolean;
  specialityIds: number[];
}) {
  const { toast } = useToast();

  const {
    data: symptoms,
    isLoading,
    isError,
    isFetched,
  } = useQuery({
    queryKey: ["symptoms-list", specialityIds],
    queryFn: () => getDoctorSymptoms(specialityIds),
    enabled: !!specialityIds.length && enabled,
  });

  useEffect(() => {
    if (isError) {
      toast({
        title: "Failed to fetch doctor symptoms",
        variant: "destructive",
      });
    }
  }, [isError, toast]);

  return { symptoms, isLoading, isFetched };
}
